import { createFileRoute } from '@tanstack/react-router';

import { IntegrationEditorPage } from '../features/demand/integrations/components/IntegrationEditorPage/IntegrationEditorPage';

export const Route = createFileRoute('/demand/integrations/create')({
  validateSearch: (search: Record<string, unknown>) => ({
    copyFrom: typeof search['copyFrom'] === 'string' ? search['copyFrom'] : undefined,
    demandPartnerId:
      typeof search['demandPartnerId'] === 'string' ? search['demandPartnerId'] : undefined,
  }),
  component: IntegrationCreateRoute,
});

function IntegrationCreateRoute() {
  const search = Route.useSearch();
  return (
    <IntegrationEditorPage
      copyFromIntegrationId={search.copyFrom}
      demandPartnerId={search.demandPartnerId}
    />
  );
}
